import { render, staticRenderFns } from "./DogInformation.vue?vue&type=template&id=033369c4"
import script from "./DogInformation.vue?vue&type=script&lang=ts"
export * from "./DogInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports